import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { ConversationThreadItem } from '../../models/Conversation';

export interface ConversationThreadResponse {
  items: ConversationThreadItem[];
}

interface GetConversationThreadPayload {
  company_id: string;
  subscription_id: string;
  phone: string;
}

export async function getConversationThread(
  payload: GetConversationThreadPayload,
  auth: Authentication,
): Promise<ConversationThreadResponse> {
  try {
    if (!payload.company_id || !payload.subscription_id || !payload.phone) {
      throw new GetConversationThreadFailure('company_id, subscription_id et phone sont requis');
    }

    const response = await HttpClient.post('/company/conversations/thread', payload, auth.token);

    return response.data as ConversationThreadResponse;
  } catch (e) {
    console.error('getConversationThread error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetConversationThreadFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetConversationThreadFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetConversationThreadFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
